import { useContext } from 'react';
import Brain from './Brain';
import Context from './Context';

const useBrain = (): Brain => useContext<Brain>(Context);

export default useBrain;
